import type { ContentBlock } from '@beidou/agent-protocol';

export const ITEM_CARD_TYPES = [
  'video_card',
  'comic_card',
  'novel_card',
  'gallery_card',
  'post_card',
  'microdrama_card',
] as const;

export type ItemCardType = (typeof ITEM_CARD_TYPES)[number];
export type ItemCardBlock = Extract<ContentBlock, { type: ItemCardType }>;

export const GRID_ONLY_CARD_TYPES = new Set<string>([
  'comic_card',
  'novel_card',
  'gallery_card',
  'post_card',
  'microdrama_card',
]);

export function isItemCardType(type: string): type is ItemCardType {
  return (ITEM_CARD_TYPES as readonly string[]).includes(type);
}

export function isItemCard(block: ContentBlock): block is ItemCardBlock {
  return isItemCardType(block.type);
}

export function carouselGridKind(items: ContentBlock[]): 'video' | 'post' {
  if (isGridOnlyCarousel(items)) return 'post';
  return 'video';
}

export function isGridOnlyCarousel(items: ContentBlock[]): boolean {
  return items.length > 0 && items.every((item) => GRID_ONLY_CARD_TYPES.has(item.type));
}
